import { render, staticRenderFns } from "./Referencias.vue?vue&type=template&id=7127d716&scoped=true"
import script from "./Referencias.vue?vue&type=script&lang=js"
export * from "./Referencias.vue?vue&type=script&lang=js"
import style0 from "./Referencias.vue?vue&type=style&index=0&id=7127d716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7127d716",
  null
  
)

export default component.exports